module.exports = __webpack_public_path__ + "img/chr_ts_11_penlight.11751218.png";